import React from 'react';
import { SecaoDebitosIcmsDrillDownModalProps } from '../../types/secaoDebitosIcmsDrillDown';
import GenericModal from '../GenericModal';
import SecaoDebitosIcmsDrillDownContent from './SecaoDebitosIcmsDrillDownContent';
import { Box, Typography, Button } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import { ProductDrillDownSkeleton } from '../Skeletons/ModalSkeletons';

const SecaoDebitosIcmsDrillDownModal: React.FC<SecaoDebitosIcmsDrillDownModalProps> = ({
  isOpen,
  onClose,
  data,
  loading,
  selectedSecao,
  error,
  onRetry
}) => {
  const renderContent = () => {
    if (error) {
      return (
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography variant="h6" color="error" gutterBottom>
            Erro ao carregar dados
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {error}
          </Typography>
          <Button
            variant="contained"
            startIcon={<RefreshIcon />}
            onClick={onRetry}
            sx={{ mt: 2 }}
          >
            Tentar Novamente
          </Button>
        </Box>
      );
    }

    if (!data) {
      return (
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography variant="body1" color="text.secondary">
            Nenhum dado disponível
          </Typography>
        </Box>
      );
    }

    return <SecaoDebitosIcmsDrillDownContent data={data} />;
  };

  return (
    <GenericModal
      open={isOpen}
      onClose={onClose}
      title="Análise Detalhada da Seção"
      loading={loading}
      showBreadcrumb={true}
      breadcrumbItems={[
        { label: 'Análises de Vendas' },
        { label: 'Débitos ICMS por Seção' },
        { label: selectedSecao?.nome || 'Seção' }
      ]}
    >
      {renderContent()}
    </GenericModal>
  );
};

export default SecaoDebitosIcmsDrillDownModal; 